var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9261 8.87421C15.9144 10.047 15.6088 11.1982 15.0373 12.2224C14.3871 13.4102 13.4103 14.387 12.2224 15.0372C10.8662 15.7655 9.30826 16.0285 7.78803 15.7858C6.2678 15.543 4.86929 14.8079 3.80731 13.6933C2.74533 12.5788 2.07858 11.1464 1.90949 9.61622C1.74039 8.08604 2.07829 6.54266 2.87128 5.22311C3.66428 3.90357 4.86852 2.88083 6.29906 2.31197C7.7296 1.74311 9.30733 1.65959 10.7899 2.07423C12.2725 2.48888 13.578 3.37876 14.5059 4.6072C15.4338 5.83565 15.9327 7.33473 15.9261 8.87421Z",
    stroke: "#FFAC06",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5706 17.5708C17.3888 17.7542 17.1724 17.8998 16.934 17.9992C16.6956 18.0985 16.4399 18.1497 16.1817 18.1497C15.9234 18.1497 15.6677 18.0985 15.4293 17.9992C15.1909 17.8998 14.9746 17.7542 14.7928 17.5708L12.2224 15.0375C13.4103 14.3873 14.3871 13.4105 15.0372 12.2227L17.5706 14.7634C17.7585 14.9457 17.9079 15.1639 18.01 15.405C18.112 15.6461 18.1646 15.9053 18.1646 16.1671C18.1646 16.4289 18.112 16.6881 18.01 16.9292C17.9079 17.1703 17.7585 17.3885 17.5706 17.5708V17.5708Z",
    stroke: "#FFAC06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 8.56309C5.4668 7.7419 5.79301 6.95435 6.37368 6.37368C6.95435 5.79301 7.7419 5.4668 8.56309 5.4668",
    stroke: "#FFAC06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.ebdde23f85f07e2b07c9de4fa88b7eb4.svg";
export { ForwardRef as ReactComponent };